import { AgencyLocation } from "./agency-location";
import { ApplicantTypeEdp } from "./applicant-type-edp";

export class GroupEdp {
    groupId: string;
    groupName: string;
    companyId: string;
    policyId: string;
    state: string;
    evidenceRequired: boolean;
    ceoiPolicy: boolean;
    adminUnits: AgencyLocation[];
    productsByApplicantType : ApplicantTypeEdp[];
}